import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getSidebarItems, filterByHiddenItemsId, clearFilters } from "../../actions/sidebarActions";
import DropDownSidebarItems from "./Components/DropDownSidebarItems";
import SidebarItem from "./Components/SidebarItem";
import SidebarBanners from "./SidebarBannersWhatsappWeb";
import './SidebarNew.css'; // Import new styles
import $ from 'jquery';

const SideBar = ({ idUser, idSeller, userType, hiddenItemsId, clearFilters }) => {
    const [sidebarItems, setSidebarItems] = useState([]);
    const [openSubmenuId, setOpenSubmenuId] = useState(null);

    const handleSubmenuToggle = (id) => {
        setOpenSubmenuId(prevId => (prevId === id ? null : id));
    };

    useEffect(() => {
        const setPageMinHeight = () => {
            const pageWrapper = document.querySelector('.page-wrapper');
            if (pageWrapper) {
                pageWrapper.style.minHeight = `${Math.max(window.innerHeight - 1, 1)}px`;
            }
        };

        setPageMinHeight();
        window.addEventListener('resize', setPageMinHeight);
        return () => window.removeEventListener('resize', setPageMinHeight);
    }, []);

    useEffect(() => {
        const sidebarItemsByUser = getSidebarItems(userType, idSeller, idUser);

        if (userType?.isProveedor) {
            setSidebarItems(sidebarItemsByUser);
        } else if (hiddenItemsId?.length > 0) {
            setSidebarItems(filterByHiddenItemsId(sidebarItemsByUser, hiddenItemsId));
        } else {
            setSidebarItems(sidebarItemsByUser);
        }
    }, [hiddenItemsId, userType, idSeller, idUser]);

    const renderSidebarItems = (item, isChildItem) => {
        if (item.childItems) {
            return (
                <DropDownSidebarItems
                    key={item.id}
                    {...item}
                    isOpen={openSubmenuId === item.id}
                    onToggle={() => handleSubmenuToggle(item.id)}
                >
                    {item.childItems.map((childItem) => renderSidebarItems(childItem, true))}
                </DropDownSidebarItems>
            )
        } else {
            return (
                <SidebarItem
                    key={item.id}
                    isChild={isChildItem}
                    clearFilters={onClearFilters}
                    {...item}
                />
            )
        }
    }

    const onClearFilters = () => {
        clearFilters(userType, idSeller);
    }

    const closeMobileSidebar = () => {
        $("body").removeClass("show-sidebar");
        window.dispatchEvent(new Event('sidebar-close'));
    };

    return (
        <>
            <aside className="left-sidebar">
                <div className="scroll-sidebar">
                    <nav className="sidebar-nav">
                        <ul id="sidebarnav" className="text-start animated fadeInLeft">
                            {sidebarItems.map((item) => { return renderSidebarItems(item) })}
                        </ul>
                    </nav>
                    <SidebarBanners />
                </div>
            </aside>
            <div
                className="mobile-sidebar-backdrop"
                onClick={closeMobileSidebar}
                aria-hidden="true"
            />
        </>
    );
}

const mapStateToProps = state => ({
    idUser: state.general.userId,
    idSeller: state.general.idSeller,
    userType: state.general.userType,
    hiddenItemsId: state.sidebar.hiddenItemsId,
})

const mapDispatchToProps = {
    clearFilters
};

export default connect(mapStateToProps, mapDispatchToProps)(SideBar);
